
import router from "./main";
import {
    Notification,
} from "element-ui";


export default {
    user: null,
   
    baseUrl: "https://localhost:7000",
    UserTypes: [
        {
            id: 1,
            name: "مركز ضمان الجودة"
        },
        {
            id: 2,
            name: 'المؤسسات'
        },

        {
            id: 3,
            name: 'المكاتب'
        },
    ],
    Sender_type: "Offices",

    OfficeUserType: [
        {
            id: 1,
            name: "ادارة متابعة المكاتب"
        },
        {
            id: 2,
            name: 'موظفين متابعة المكاتب'
        },
        {
            id: 4,
            name: 'مدير مكتب العمل'
        },
        {
            id: 3,
            name: 'موظف مكتب العمل'
        },
    ],
    Logout() {
        debugger;
        this.user = null;
        this.token = null;
        console.log(router)
       
        router.push("/login");
        Notification.error({
            title: 'تسجيل الخروج',
            message: 'تـم تسجيل خروجك من النظام بنجاح',
            position: 'bottom-left'
        });
    },


   

};
